export default __webpack_public_path__ + "static/media/KONNECT DIGITAL SMILEY-01.4dc6083a.png";